import { PHOTO_RATING, PHOTO_RATING_NUM, PHOTO_RATING_BAR } from "../constants"

class StarsElement {
  constructor(containerElement, numElement, barElement) {
    this.containerElement = containerElement
    this.numElement = numElement
    this.barElement = barElement
  }

  static fromHtmlElement(htmlElement) {
    const containerElement = htmlElement.querySelector(PHOTO_RATING)
    if (!containerElement) return null

    const numElement = containerElement.querySelector(PHOTO_RATING_NUM)
    const barElement = containerElement.querySelector(PHOTO_RATING_BAR)

    return new StarsElement(containerElement, numElement, barElement)
  }

  // Calculate rating bar width using the same logic as rating_bar_width helper
  ratingBarWidth(attrValue) {
    if (!attrValue) return 0
    // dead zone: 4 left, 3 right
    // active zone: 20-7=13
    // total active zone: 13*5=65
    // 1.0 must correspond to one full star, i.e. anything between 4+13 and 4+13+3+4
    const fraction = attrValue / 5 // 0.0 to 1.0, fill rate
    const activePixels = fraction * 65
    const passivePixels = 4 + Math.floor(attrValue) * 7
    let totalPixels = activePixels + passivePixels
    totalPixels = totalPixels > 100 ? 100 : totalPixels
    return Math.round(totalPixels)
  }

  apply(photo) {
    if (!this.containerElement) return

    const hasStars = photo.stars !== null && photo.stars !== undefined

    // Update or create rating number element
    if (hasStars) {
      if (!this.numElement) {
        // Create the element if it doesn't exist
        this.numElement = document.createElement("div")
        this.numElement.className = "js-gallery-photo-rating-num"
        this.numElement.id = "photo_avg_rating"
        this.containerElement.appendChild(this.numElement)
      }
      this.numElement.textContent = photo.stars.toFixed(1)
      this.numElement.style.display = ""
    } else if (this.numElement) {
      // Hide if no stars but element exists
      this.numElement.style.display = "none"
    }

    // Update or create rating bar element
    if (hasStars) {
      if (!this.barElement) {
        // Create the element if it doesn't exist
        this.barElement = document.createElement("div")
        this.barElement.className = "js-gallery-photo-rating-bar"
        // Insert before numElement if it exists, otherwise append
        if (this.numElement) {
          this.containerElement.insertBefore(this.barElement, this.numElement)
        } else {
          this.containerElement.appendChild(this.barElement)
        }
      }
      const width = this.ratingBarWidth(photo.stars)
      const innerBar = this.barElement.querySelector(".star_bar > div")
      if (innerBar) {
        innerBar.style.width = `${width}px`
      } else {
        // If structure is different, replace the entire rating bar HTML
        this.barElement.innerHTML = `<div class="star_bar"><div style="width: ${width}px;"></div></div>`
      }
      this.barElement.style.display = ""
    } else if (this.barElement) {
      // Hide if no stars but element exists
      this.barElement.style.display = "none"
    }
  }
}

export default StarsElement
